import { Component, OnInit, Input, HostListener, Output, EventEmitter, HostBinding } from '@angular/core';

@Component({
  selector: '[tableOrder]',
  templateUrl: './table-title-order.component.html',
  styleUrls: ['./table-title-order.component.scss']
})
export class TableTitleOrderComponent implements OnInit {

  @Input('tableOrder') order = '';
  @Output('tableOrderChange') orderChange = new EventEmitter();
  @Input('tableOrderGroup') orderGroup;
  @HostBinding('class.bg-light') actived: boolean = false;



  constructor() { }

  ngOnInit() {
    this.actived = this.order != '';
  }
  ngOnChanges() {
    this.actived = this.order != '';
  }

  @HostListener("click") change() {
    const order = this.order.toLocaleLowerCase();

    if (this.orderGroup) {
      for (const key in this.orderGroup) {
        if (this.orderGroup[key] != this.order) {
          this.orderGroup[key] = '';
        }
      }
    }

    switch (order) {
      case '':
        this.order = 'asc';
        break;

      case 'asc':
        this.order = 'desc';
        break;

      case 'desc':
        this.order = 'asc';
        break;

      default:
        this.order = '';
        break;
    }

    this.actived = this.order != '';
    this.orderChange.emit(this.order);
  }


}
